import {
  currencyrateDetailsFragment,
  currencyrateFragment
} from "@saleor/fragments/currencyrate";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  CurrencyrateDetails,
  CurrencyrateDetailsVariables
} from "./types/CurrencyrateDetails";
import {
  CurrencyrateEvent
} from "./types/CurrencyrateEvent";
import {
  CurrencyrateList,
  CurrencyrateListVariables
} from "./types/CurrencyrateList";
import { Onlinerates } from "./types/Onlinerates";

const currencyrateList = gql`
  ${currencyrateFragment}
  ${pageInfoFragment}
  query CurrencyrateList(
    $filter: CurrencyrateFilterInput
    $before: String
    $after: String
    $first: Int
    $last: Int
    $sort: CurrencyrateSortingInput
  ) {
    currencyrates(
      filter: $filter
      before: $before
      after: $after
      first: $first
      last: $last
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          ...CurrencyrateFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
  }
`;

export const useCurrencyrateListQuery = makeQuery<
  CurrencyrateList,
  CurrencyrateListVariables
>(currencyrateList);

const onlinerates = gql`
  query Onlinerates {
    onlinerates {
      toCurrency
      rate
    }
  }
`;

export const useOnlineratesQuery = makeQuery<Onlinerates, null>(onlinerates);

const currencyrateDetails = gql`
  ${currencyrateDetailsFragment}
  query CurrencyrateDetails($id: ID!) {
    currencyrate(id: $id) {
      ...CurrencyrateDetailsFragment
    }
  }
`;

export const useCurrencyrateDetailsQuery = makeQuery<
  CurrencyrateDetails,
  CurrencyrateDetailsVariables
>(currencyrateDetails);

const currencyrateEvent = gql`
  query CurrencyrateEvent{
    currencyrateEvent{
      id
      user
      type
      currencyrate
      date
    }
  }
`;

export const useCurrencyrateEventQuery = makeQuery<
  CurrencyrateEvent,
  {}
>(currencyrateEvent)